import React from 'react';

import { OpenConvalidaInfoResponse, Group } from 'models/response';

import utils from 'utils';

import { Title } from './index';
import CheckGrouper from 'components/Grouper/CheckGrouper';
import Table from 'components/Table';
interface Props {
  response: OpenConvalidaInfoResponse;
  selectedGroups: Group[];
}

const columns = [
  { accessor: 'username', Header: 'User' },
  { accessor: 'name', Header: 'Name' },
];

const Groups = (props: Props) => {
  const { response, selectedGroups } = props;
  const t = utils.intl.useTranslator();

  const renderGroups = () => {
    const contentGroup = response.groups?.map((group, index: number) => {
      return (
        <CheckGrouper
          customMargin={'15px 0'}
          title={group.groupName}
          key={`${index}-${group.idGroup}`}
          selectable={true}
          isSelected={selectedGroups?.find((e) => e.idGroup === group.idGroup) ? true : false}
          isEditable={false}
        >
          <Table
            id={`table-group-${group.idGroup}`}
            key={group.idGroup}
            columns={columns}
            rows={group.users}
            rowId="idUser"
            hasSort
            light
          />
        </CheckGrouper>
      );
    });
    return contentGroup;
  };

  return (
    <>
      <Title>{t('destinatario')}</Title>
      {response ? renderGroups() : null}
    </>
  );
};

export default Groups;
